import { PORTAL_SPECIFIC } from 'customer-data-objects/constants/MetaTypes';

/**
 * Checks the objectTypeDef partial object to see if the object is portal-specific (i.e an indirect check if the Portal is Standard type)
 * @param objectTypeDef a Partial ObjectTypeDefinition that needs to have metaTypeId key
 */

export const getIsPortalSpecific = objectTypeDef => objectTypeDef.metaTypeId === PORTAL_SPECIFIC;